import React from "react";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import image from "../../../Assets/Contact/horizontal.jpg"
const ServiceSideSticky = () => {
  const navigate = useNavigate();
  return (
    <aside className="lg:w-[30%] w-full flex flex-col gap-y-10 lg:max-h-[100vh] overflow-y-auto lg:sticky lg:top-24 self-start jakarta-font">
      <div data-aos="fade-up" data-aos-duration="700" className="flex flex-col gap-y-5 p-5 rounded-3xl bg-[#0BB6D9] text-white">
        <h1 data-aos="fade-up" data-aos-duration="700" className="font-bold text-3xl familjen-font">
          Contact us for help
        </h1>
        <p data-aos="fade-up" data-aos-duration="700" className="familjen-font">
          Get in touch and let us know how we can help touch as soon as
          possible.
        </p>
        <button data-aos="fade-up" data-aos-duration="700"
          className="bg-white text-black hover:bg-black familjen-font hover:text-white transition-all duration-500 delay-75  w-fit p-3 rounded-sm font-semibold uppercase flex items-center gap-3"
          onClick={() => {
            navigate("/contact");
            window.scrollTo(0, 0);
          }}
        >
          {" "}
          contact us now
          <span>
            <FaArrowRight />
          </span>
        </button>
        <figure data-aos={"zoom-in"} data-aos-duration="700" className="w-full h-full rounded-3xl overflow-hidden">
          <img
            className="h-full w-full object-cover"
            src={image}
            alt=""
          />
        </figure>
      </div>
    </aside>
  );
};

export default ServiceSideSticky;
